export default __webpack_public_path__ + "static/media/dev.b3efe267.jpg";